(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const featuredSelector = '.product-card--featured .product-card__content';

    // Wrap non-gallery children once so featured cards can center the right-side content as one stack.
    const syncFeaturedProductCardLayout = (root = document) => {
      const featuredCards = root.querySelectorAll(featuredSelector);

      for (const content of featuredCards) {
        if (!content.closest(".product-grid__item[data-featured-collection-card='true']")) continue;

        if (content.querySelector('.product-card__featured-details')) continue;

        const gallery = content.querySelector('.card-gallery');
        if (!gallery) continue;

        const detailNodes = Array.from(content.children).filter((child) => child !== gallery);
        if (detailNodes.length === 0) continue;

        const detailsWrapper = document.createElement('div');
        detailsWrapper.className = 'product-card__featured-details';

        for (const node of detailNodes) {
          detailsWrapper.appendChild(node);
        }

        content.appendChild(detailsWrapper);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => syncFeaturedProductCardLayout(), { once: true });
    } else {
      syncFeaturedProductCardLayout();
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          if (node.matches?.(featuredSelector)) {
            syncFeaturedProductCardLayout(node.parentElement || document);
            continue;
          }

          if (node.querySelector?.(featuredSelector)) {
            syncFeaturedProductCardLayout(node);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
